import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=66fdedb1&scoped=true"
import script from "./Imprint.vue?vue&type=script&lang=ts"
export * from "./Imprint.vue?vue&type=script&lang=ts"
import style0 from "./Imprint.vue?vue&type=style&index=0&id=66fdedb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fdedb1",
  null
  
)

export default component.exports